import axios from 'axios';
import { useQueries, useQuery } from 'react-query';
import { KA_API_URL } from '../../config/baseUrl';

/**
 * Requests
 */

export const getStaffingRecommendations = async config => axios.post(`${KA_API_URL}/staffing/recommendations`, config);
export const getHOORecommendations = async config =>
  axios.post(`${KA_API_URL}/hours_of_operation/recommendations`, config);

/**
 * Hooks
 */

const STAFFING_RECOMMENDATIONS_QUERY_KEY_BASE = 'staffingRecommendations';
const HOO_RECOMMENDATIONS_QUERY_KEY_BASE = 'hooRecommendations';
const STAFFING_RECOMMENDATIONS_BY_LOCATIONS_QUERY_KEY_BASE = 'staffingRecommendationsByLocations';
const HOO_RECOMMENDATIONS_BY_LOCATIONS_QUERY_KEY_BASE = 'hooRecommendationsByLocations';

export const useStaffingRecommendations = (config, extraKey, options) =>
  useQuery(
    [STAFFING_RECOMMENDATIONS_QUERY_KEY_BASE, config, extraKey],
    async () => {
      const response = await getStaffingRecommendations(config);
      return response?.data ?? [];
    },
    {
      enabled: !!config,
      ...options,
    },
  );

export const useHOORecommendations = (config, extraKey, options) =>
  useQuery(
    [HOO_RECOMMENDATIONS_QUERY_KEY_BASE, config, extraKey],
    async () => {
      const response = await getHOORecommendations(config);
      return response?.data ?? [];
    },
    {
      enabled: !!config,
      ...options,
    },
  );

export const useStaffingRecommendationsByLocations = (baseConfig, locationIds, options) => {
  const queries = useQueries(
    locationIds.map(locationId => ({
      queryKey: [STAFFING_RECOMMENDATIONS_BY_LOCATIONS_QUERY_KEY_BASE, locationId, baseConfig],
      queryFn: () =>
        getStaffingRecommendations({
          ...baseConfig,
          location_id: locationId,
        }).then(res => res.data ?? []),
      enabled: !!baseConfig && locationIds.length > 0,
      ...options,
    })),
  );

  const dataByLocation = queries.reduce((acc, q, idx) => {
    acc[locationIds[idx]] = q.data;
    return acc;
  }, {});

  const isLoading = queries.some(q => q.isLoading);
  const isFetching = queries.some(q => q.isFetching);

  return {
    dataByLocation,
    isLoading,
    isFetching,
  };
};

export const useHOORecommendationsByLocations = (baseConfig, locationIds, options) => {
  const queries = useQueries(
    locationIds.map(locationId => ({
      queryKey: [HOO_RECOMMENDATIONS_BY_LOCATIONS_QUERY_KEY_BASE, locationId, baseConfig],
      queryFn: () =>
        getHOORecommendations({
          ...baseConfig,
          location_id: locationId,
        }).then(res => res.data ?? []),
      enabled: !!baseConfig && locationIds.length > 0,
      ...options,
    })),
  );

  const dataByLocation = queries.reduce((acc, q, idx) => {
    acc[locationIds[idx]] = q.data;
    return acc;
  }, {});

  const isLoading = queries.some(q => q.isLoading);
  const isFetching = queries.some(q => q.isFetching);

  return {
    dataByLocation,
    isLoading,
    isFetching,
  };
};
